import { CommonModule } from '@angular/common';
import { TwoColumnLayoutComponent } from './two-column-layout/two-column-layout.component';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [TwoColumnLayoutComponent],
  imports: [CommonModule],
  exports: [TwoColumnLayoutComponent],
})
export class CanvasLayoutsModule {}
